import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";
import { ConsoleLayout } from "@/components/ConsoleLayout";
import Home from "@/pages/Home";
import GameResults from "@/pages/GameResults";
import DrawDetail from "@/pages/DrawDetail";
import Verify from "@/pages/Verify";
import Ledger from "@/pages/Ledger";
import Documentacion from "@/pages/Documentacion";
import Login from "@/pages/Login";
import GuiaTecnica from "@/pages/GuiaTecnica";
import Expediente from "@/pages/Expediente";
import NotFound from "@/pages/NotFound";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Overview from "@/pages/console/Overview";
import Games from "@/pages/console/Games";
import Draws from "@/pages/console/Draws";
import Audit from "@/pages/console/Audit";
import Users from "@/pages/console/Users";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/juego/:tipo" element={<GameResults />} />
              <Route path="/sorteo/:id" element={<DrawDetail />} />
              <Route path="/verificar" element={<Verify />} />
              <Route path="/bitacora" element={<Ledger />} />
              <Route path="/documentacion" element={<Documentacion />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/guia-tecnica" element={<GuiaTecnica />} />
            <Route path="/expediente" element={<Expediente />} />
            <Route
              path="/consola"
              element={
                <ProtectedRoute>
                  <ConsoleLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="juegos" element={<Games />} />
              <Route path="sorteos" element={<Draws />} />
              <Route path="auditoria" element={<Audit />} />
              <Route
                path="usuarios"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <Users />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
